import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Modal,
  TextField,
  AppBar,
  Toolbar,
  Paper,
  Typography,
  Tooltip
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const EditDesignation = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [designationName, setDesignationName] = useState('');
  const [departmentId, setDepartmentId] = useState('');
  const { desigId } = useParams();
  const navigate = useNavigate();

  // Static data for departments
  const staticDepartmentData = [
    { deptId: 1, departmentName: 'Administration' },
    { deptId: 2, departmentName: 'Finance' },
    { deptId: 3, departmentName: 'IT' },
    { deptId: 4, departmentName: 'Management' },
    { deptId: 5, departmentName: 'Marketing' },
    { deptId: 6, departmentName: 'Reception' },
  ];

  // Static designation data to pre-fill based on desigId
  const staticDesignationData = [
    { desigId: 1, deptId: 1, designationName: 'Manager' },
    { desigId: 2, deptId: 2, designationName: 'Accountant' },
    { desigId: 3, deptId: 3, designationName: 'Developer' },
    { desigId: 4, deptId: 4, designationName: 'Director' },
    { desigId: 5, deptId: 5, designationName: 'Specialist' },
    { desigId: 6, deptId: 6, designationName: 'Receptionist' },
  ];

  useEffect(() => {
    const designation = staticDesignationData.find(desig => desig.desigId === parseInt(desigId));
    if (designation) {
      setDesignationName(designation.designationName);
      setDepartmentId(designation.deptId);
    } else {
      alert('Designation not found');
    }
  }, [desigId]);

  const handleUpdate = () => {
    if (designationName && departmentId) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Designation
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="department-label">Department</InputLabel>
            <Select
              labelId="department-label"
              id="department"
              value={departmentId}
              label="Department"
              onChange={(e) => setDepartmentId(e.target.value)}
            >
              {staticDepartmentData.map((department) => (
                <MenuItem key={department.deptId} value={department.deptId}>
                  {department.departmentName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Designation Name"
            variant="outlined"
            fullWidth
            value={designationName}
            onChange={(e) => setDesignationName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!designationName ? "Enter Designation Name" : !departmentId ? "Select Department" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!designationName || !departmentId}
              >
                Update
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
           data-app-cancel="true">
            Cancel
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Designation Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Designation Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditDesignation;
